var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 21c.31 0 .563-.252.563-.563v-3.375h2.25c.31 0 .562-.251.562-.562V12a2.813 2.813 0 00-2.813-2.813V6.511c0-.447-.177-.876-.494-1.193L15.87 3.494A1.688 1.688 0 0014.676 3H6.884c-.592 0-1.072.504-1.072 1.125v5.063A2.813 2.813 0 003 12v4.5c0 .31.252.563.563.563h2.25v3.375c0 .31.251.562.562.562h11.25zm-.33-8.47a.53.53 0 110 1.058.53.53 0 010-1.059zM14.25 5.25v1.688c0 .31.252.562.563.562H16.5v2.25h-9v-4.5h6.75zm2.25 14.625h-9v-2.25h9v2.25z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/7d892a7d61495e860c68bf83609c7dc1-Print.svg";
export { SvgPrint as ReactComponent };